import { BONUS_OFFERS_300X250_VIEW } from './types';

export const triggerBonusOffers300x250IsViewed = offer => ({
  type: BONUS_OFFERS_300X250_VIEW,
  offer,
});
